import {
  SEARCH,
} from './fields';

export default function payload() {
  return {
    q: {
      field: SEARCH,
    },
  };
}
